import { render, staticRenderFns } from "./updates-form.vue?vue&type=template&id=2f19af51&scoped=true&"
import script from "./updates-form.vue?vue&type=script&lang=js&"
export * from "./updates-form.vue?vue&type=script&lang=js&"
import style0 from "./updates-form.vue?vue&type=style&index=0&id=2f19af51&prod&lang=scss&"
import style1 from "./updates-form.vue?vue&type=style&index=1&id=2f19af51&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f19af51",
  null
  
)

export default component.exports